import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = {
  class: "card mb-5 mb-xl-10",
  id: "print"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header ribbon ribbon-end\"><div class=\"ribbon-label bg-primary\">Penjualan</div><div class=\"card-title\"><span class=\"d-flex flex-column\"><span class=\"fw-bolder fs-6\">Detail Invoices</span><span class=\"fs-7 text-muted\">Manajemen Data Sekolah</span></span></div></div>", 1)
const _hoisted_4 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-6 mb-2" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", null, " Nomor Order ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_11 = { class: "col-8" }
const _hoisted_12 = { class: "col-lg-6 mb-2" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", null, " No VA ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_16 = { class: "col-8 col-lg-5" }
const _hoisted_17 = { class: "row mb-2" }
const _hoisted_18 = { class: "col-lg-6 mb-2" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", null, " Tanggal ")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_22 = { class: "col-8 col-lg-5" }
const _hoisted_23 = { class: "col-lg-6 mb-2" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", null, " Bank VA ")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_27 = { class: "col-8 col-lg-5" }
const _hoisted_28 = { class: "row mb-1 mt-5" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bolder fs-4" }, "Pelanggan")
], -1)
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-12 col-lg-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Nama Sekolah", -1)
const _hoisted_34 = { class: "col-12 col-lg-6" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Jatuh Tempo", -1)
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-12 col-lg-6" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Alamat", -1)
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-12 col-lg-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "No Telp", -1)
const _hoisted_42 = { class: "card-body py-1" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bolder fs-4" }, "Pelanggan")
  ])
], -1)
const _hoisted_44 = { class: "table-responsive" }
const _hoisted_45 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Keterangan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Kuantitas"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Harga"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Diskon"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Pajak"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Jumlah")
  ])
], -1)
const _hoisted_47 = { class: "text-center" }
const _hoisted_48 = { class: "text-center" }
const _hoisted_49 = { class: "text-center" }
const _hoisted_50 = { class: "text-center" }
const _hoisted_51 = { class: "text-center" }
const _hoisted_52 = { class: "text-center" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, null, -1)
const _hoisted_54 = { class: "text-center" }
const _hoisted_55 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Subtotal", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_63 = { class: "min-w-150px; text-center" }
const _hoisted_64 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-left" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Pajak", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_72 = { class: "min-w-150px; text-center" }
const _hoisted_73 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-left pb-0" }, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Diskon", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_81 = { class: "min-w-150px; text-center" }
const _hoisted_82 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, null, -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-left pb-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "col-lg-6 col-form-label fw-bold fs-6" }, "Terbilang")
], -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Biaya Pengiriman", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_90 = { class: "min-w-150px; text-center" }
const _hoisted_91 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, null, -1)
const _hoisted_93 = {
  colspan: "3",
  class: "min-w-150px; text-center"
}
const _hoisted_94 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-150px; text-center",
  style: {"vertical-align":"top"}
}, " Total Biaya ", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_97 = {
  class: "min-w-150px; text-center",
  style: {"vertical-align":"top"}
}
const _hoisted_98 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_99 = {
  class: "modal fade",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_print",
  ref: "printModalRef"
}
const _hoisted_100 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_101 = { class: "modal-content rounded" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "modal-title mb-6" }, "Tampilan Invoice"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_103 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-5" }
const _hoisted_104 = { class: "table-responsive" }
const _hoisted_105 = {
  id: "capturepdf",
  class: "pa-2 ma-2",
  style: {"transform":"scale(0.85)"}
}
const _hoisted_106 = {
  style: {"width":"100% !important","margin-top":"10px"},
  class: "fontprint mb-1"
}
const _hoisted_107 = /*#__PURE__*/_createElementVNode("tr", { class: "fontprint" }, [
  /*#__PURE__*/_createElementVNode("td", {
    style: {"text-align":"left","font-size":"23px","font-weight":"700"},
    colspan: "4"
  }, " PT TEKNOLOGI KARTU INDONESIA "),
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"215px","text-align":"right"} }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/media/LogoTKI.JPG",
      class: "mr-auto",
      style: {"margin-left":"10px !important"}
    })
  ])
], -1)
const _hoisted_108 = { class: "fontprint" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("td", {
  style: {"text-align":"left","font-size":"14px"},
  colspan: "3"
}, [
  /*#__PURE__*/_createElementVNode("p", null, "Jl Nakula Sadewa No 17B, Dukuh, Kec Sidomukti, Kota Salatiga"),
  /*#__PURE__*/_createElementVNode("p", null, "Telp: 081329339993"),
  /*#__PURE__*/_createElementVNode("p", null, "Email: teknologikartuindonesia@gmail.com")
], -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"center","font-weight":"700"} }, [
  /*#__PURE__*/_createElementVNode("p", null, "#INVOICE"),
  /*#__PURE__*/_createElementVNode("p", null, "TANGGAL")
], -1)
const _hoisted_111 = { style: {"width":"215px","text-align":"left"} }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("tr", { class: "fontprint" }, [
  /*#__PURE__*/_createElementVNode("td", {
    style: {"text-align":"left"},
    colspan: "3"
  }, [
    /*#__PURE__*/_createElementVNode("hr", { style: {"border":"3px solid black","margin-right":"10px !important"} })
  ]),
  /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"center","font-weight":"700"} }, [
    /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"0px","font-size":"23px"} }, "INVOICE")
  ]),
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"215px","text-align":"left"} }, [
    /*#__PURE__*/_createElementVNode("hr", { style: {"border":"3px solid black","margin-left":"10px !important"} })
  ])
], -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("tr", { class: "fontprint" }, [
  /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left"} }, [
    /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"600","margin-left":"10px !important"} }, " PELANGGAN ")
  ]),
  /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"center"} }),
  /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left"} })
], -1)
const _hoisted_114 = { class: "fontprint" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"125px","text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("p", null, "Nama"),
  /*#__PURE__*/_createElementVNode("p", null, "Alamat"),
  /*#__PURE__*/_createElementVNode("p", null, "Telp")
], -1)
const _hoisted_116 = {
  style: {"text-align":"left"},
  colspan: "2"
}
const _hoisted_117 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("p", null, "Jatuh Tempo")
], -1)
const _hoisted_118 = { style: {"text-align":"center"} }
const _hoisted_119 = { colspan: "5" }
const _hoisted_120 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-top":"1px solid black","border-bottom":"1px solid black"} }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Keterangan"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Kuantitas"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Harga (Rp)"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Diskon"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Pajak"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Jumlah(Rp)")
  ])
], -1)
const _hoisted_122 = { class: "text-center" }
const _hoisted_123 = { class: "text-center" }
const _hoisted_124 = { class: "text-center" }
const _hoisted_125 = { class: "text-center" }
const _hoisted_126 = { class: "text-center" }
const _hoisted_127 = { class: "text-center" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, null, -1)
const _hoisted_129 = { class: "text-center" }
const _hoisted_130 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, null, -1)
const _hoisted_132 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_134 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-150px; text-left",
  style: {"border-bottom":"1px solid black","padding-left":"50px !important"}
}, " Subtotal ", -1)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-150px; text-center",
  style: {"border-bottom":"1px solid black"}
}, null, -1)
const _hoisted_138 = {
  class: "min-w-150px; text-center",
  style: {"border-bottom":"1px solid black"}
}
const _hoisted_139 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, null, -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-left pb-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "col-lg-6 col-form-label fw-bold fs-6" }, "Terbilang")
], -1)
const _hoisted_142 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-150px; text-left",
  style: {"border-bottom":"1px solid black","padding-left":"50px !important"}
}, " Pajak ", -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-150px; text-center",
  style: {"border-bottom":"1px solid black"}
}, null, -1)
const _hoisted_147 = {
  class: "min-w-150px; text-center",
  style: {"border-bottom":"1px solid black"}
}
const _hoisted_148 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, null, -1)
const _hoisted_150 = {
  colspan: "3",
  class: "min-w-150px; text-left"
}
const _hoisted_151 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-150px; text-left",
  style: {"border-bottom":"1px solid black","padding-left":"50px !important"}
}, " Diskon ", -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-150px; text-center",
  style: {"border-bottom":"1px solid black"}
}, null, -1)
const _hoisted_155 = {
  class: "min-w-150px; text-center",
  style: {"border-bottom":"1px solid black"}
}
const _hoisted_156 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, null, -1)
const _hoisted_158 = {
  colspan: "3",
  class: "min-w-150px; text-left"
}
const _hoisted_159 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_160 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-150px; text-left",
  style: {"border-bottom":"1px solid black","padding-left":"50px !important"}
}, " Biaya Pengiriman ", -1)
const _hoisted_161 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-150px; text-center",
  style: {"border-bottom":"1px solid black"}
}, null, -1)
const _hoisted_162 = {
  class: "min-w-150px; text-center",
  style: {"border-bottom":"1px solid black"}
}
const _hoisted_163 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_164 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, null, -1)
const _hoisted_165 = {
  colspan: "3",
  class: "min-w-150px; text-left"
}
const _hoisted_166 = ["src"]
const _hoisted_167 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_168 = /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-150px; text-left",
  style: {"vertical-align":"top","padding-left":"50px !important"}
}, " Total Biaya ", -1)
const _hoisted_169 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, null, -1)
const _hoisted_170 = {
  class: "min-w-150px; text-center",
  style: {"vertical-align":"top"}
}
const _hoisted_171 = { class: "modal-footer" }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_173 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "number",
                    class: "form-control form-control-lg",
                    disabled: "",
                    modelValue: _ctx.Data.number,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.Data.number) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "number",
                    class: "form-control form-control-lg",
                    disabled: "",
                    modelValue: _ctx.Data.vaNumber,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.Data.vaNumber) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "number",
                    class: "form-control form-control-lg",
                    disabled: "",
                    modelValue: _ctx.Data.invoiceDate,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.Data.invoiceDate) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "number",
                    class: "form-control form-control-lg",
                    disabled: "",
                    modelValue: _ctx.Data.vaBank,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.Data.vaBank) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "schoolName",
                    class: "form-control form-control-lg",
                    disabled: "",
                    modelValue: _ctx.Data.schoolName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.Data.schoolName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "expiredDate",
                    class: "form-control form-control-lg",
                    disabled: "",
                    modelValue: _ctx.Data.expiredDate,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.Data.expiredDate) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "schoolName",
                    class: "form-control form-control-lg",
                    disabled: "",
                    modelValue: _ctx.Data.address,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.Data.address) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "schoolName",
                    class: "form-control form-control-lg",
                    disabled: "",
                    modelValue: _ctx.Data.phone,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.Data.phone) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("table", _hoisted_45, [
              _hoisted_46,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail, (detail, index) => {
                return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_47, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", _hoisted_48, _toDisplayString(detail.name), 1),
                    _createElementVNode("td", _hoisted_49, _toDisplayString(detail.qty), 1),
                    _createElementVNode("td", _hoisted_50, "Rp." + _toDisplayString(_ctx.formatPrice(detail.price)), 1),
                    _createElementVNode("td", _hoisted_51, _toDisplayString(detail.discount) + " %", 1),
                    _createElementVNode("td", _hoisted_52, _toDisplayString(detail.tax) + " %", 1),
                    _hoisted_53,
                    _createElementVNode("td", _hoisted_54, " Rp. " + _toDisplayString(_ctx.formatPrice(detail.price * detail.qty)), 1)
                  ])
                ]))
              }), 128)),
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_55, [
                  _hoisted_56,
                  _hoisted_57,
                  _hoisted_58,
                  _hoisted_59,
                  _hoisted_60,
                  _hoisted_61,
                  _hoisted_62,
                  _createElementVNode("th", _hoisted_63, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.Data.amount)), 1)
                ]),
                _createElementVNode("tr", _hoisted_64, [
                  _hoisted_65,
                  _hoisted_66,
                  _hoisted_67,
                  _hoisted_68,
                  _hoisted_69,
                  _hoisted_70,
                  _hoisted_71,
                  _createElementVNode("th", _hoisted_72, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.Data.tax)), 1)
                ]),
                _createElementVNode("tr", _hoisted_73, [
                  _hoisted_74,
                  _hoisted_75,
                  _hoisted_76,
                  _hoisted_77,
                  _hoisted_78,
                  _hoisted_79,
                  _hoisted_80,
                  _createElementVNode("th", _hoisted_81, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.Data.discount)), 1)
                ]),
                _createElementVNode("tr", _hoisted_82, [
                  _hoisted_83,
                  _hoisted_84,
                  _hoisted_85,
                  _hoisted_86,
                  _hoisted_87,
                  _hoisted_88,
                  _hoisted_89,
                  _createElementVNode("th", _hoisted_90, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.Data.shipping)), 1)
                ]),
                _createElementVNode("tr", _hoisted_91, [
                  _hoisted_92,
                  _createElementVNode("th", _hoisted_93, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "note",
                      class: "form-control form-control-lg",
                      disabled: "",
                      modelValue: _ctx.Data.wordCurrency,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.Data.wordCurrency) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _hoisted_94,
                  _hoisted_95,
                  _hoisted_96,
                  _createElementVNode("th", _hoisted_97, " Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.Data.totalAmount)), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_98, [
          _createElementVNode("button", {
            class: "btn btn-success me-3",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.printpreview()))
          }, " Download "),
          _createElementVNode("button", {
            class: "btn btn-danger me-3",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push('/superadmin/invoices')))
          }, " Tutup ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_99, [
      _createElementVNode("div", _hoisted_100, [
        _createElementVNode("div", _hoisted_101, [
          _hoisted_102,
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("div", _hoisted_105, [
                _createElementVNode("table", _hoisted_106, [
                  _hoisted_107,
                  _createElementVNode("tr", _hoisted_108, [
                    _hoisted_109,
                    _hoisted_110,
                    _createElementVNode("td", _hoisted_111, [
                      _createElementVNode("p", null, ": " + _toDisplayString(_ctx.Data.number), 1),
                      _createElementVNode("p", null, ": " + _toDisplayString(_ctx.Data.invoiceDate), 1)
                    ])
                  ]),
                  _hoisted_112,
                  _hoisted_113,
                  _createElementVNode("tr", _hoisted_114, [
                    _hoisted_115,
                    _createElementVNode("td", _hoisted_116, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.cekNull(_ctx.Data.schoolName)), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.cekNull(_ctx.Data.address)), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.cekNull(_ctx.Data.phone)), 1)
                    ]),
                    _hoisted_117,
                    _createElementVNode("td", _hoisted_118, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.Data.expiredDate), 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_119, [
                      _createElementVNode("table", _hoisted_120, [
                        _hoisted_121,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail, (detail, index) => {
                          return (_openBlock(), _createElementBlock("tbody", {
                            style: {"border-bottom":"1px solid black"},
                            key: index
                          }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_122, _toDisplayString(index + 1), 1),
                              _createElementVNode("td", _hoisted_123, _toDisplayString(detail.name), 1),
                              _createElementVNode("td", _hoisted_124, _toDisplayString(detail.qty), 1),
                              _createElementVNode("td", _hoisted_125, _toDisplayString(_ctx.formatPrice(detail.price)), 1),
                              _createElementVNode("td", _hoisted_126, _toDisplayString(detail.discount) + " %", 1),
                              _createElementVNode("td", _hoisted_127, _toDisplayString(detail.tax) + " %", 1),
                              _hoisted_128,
                              _createElementVNode("td", _hoisted_129, _toDisplayString(_ctx.formatPrice(detail.price * detail.qty)), 1)
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_130, [
                            _hoisted_131,
                            _hoisted_132,
                            _hoisted_133,
                            _hoisted_134,
                            _hoisted_135,
                            _hoisted_136,
                            _hoisted_137,
                            _createElementVNode("th", _hoisted_138, _toDisplayString(_ctx.formatPrice(_ctx.Data.amount)), 1)
                          ]),
                          _createElementVNode("tr", _hoisted_139, [
                            _hoisted_140,
                            _hoisted_141,
                            _hoisted_142,
                            _hoisted_143,
                            _hoisted_144,
                            _hoisted_145,
                            _hoisted_146,
                            _createElementVNode("th", _hoisted_147, _toDisplayString(_ctx.formatPrice(_ctx.Data.tax)), 1)
                          ]),
                          _createElementVNode("tr", _hoisted_148, [
                            _hoisted_149,
                            _createElementVNode("th", _hoisted_150, [
                              _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.Data.wordCurrency), 1)
                            ]),
                            _hoisted_152,
                            _hoisted_153,
                            _hoisted_154,
                            _createElementVNode("th", _hoisted_155, _toDisplayString(_ctx.formatPrice(_ctx.Data.discount)), 1)
                          ]),
                          _createElementVNode("tr", _hoisted_156, [
                            _hoisted_157,
                            _createElementVNode("th", _hoisted_158, " No VA : " + _toDisplayString(_ctx.Data.vaNumber), 1),
                            _hoisted_159,
                            _hoisted_160,
                            _hoisted_161,
                            _createElementVNode("th", _hoisted_162, _toDisplayString(_ctx.formatPrice(_ctx.Data.shipping)), 1)
                          ]),
                          _createElementVNode("tr", _hoisted_163, [
                            _hoisted_164,
                            _createElementVNode("th", _hoisted_165, [
                              _createElementVNode("img", {
                                alt: "",
                                class: "img-fluid",
                                style: {"max-width":"150px !important"},
                                src: _ctx.imageFotoBank
                              }, null, 8, _hoisted_166)
                            ]),
                            _hoisted_167,
                            _hoisted_168,
                            _hoisted_169,
                            _createElementVNode("th", _hoisted_170, _toDisplayString(_ctx.formatPrice(_ctx.Data.totalAmount)), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_171, [
              _hoisted_172,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-success",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.printpdf())),
                disabled: _ctx.disableButton
              }, " Print PDF ", 8, _hoisted_173)
            ])
          ])
        ])
      ])
    ], 512)
  ], 64))
}